<ion-header>
  <ion-toolbar>
    <ion-title>{{ "NewCustomer.search" | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">{{
        "General.lukk" | translate
      }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-item class="input-search">
    <ion-icon name="search-outline"></ion-icon>
    &nbsp;&nbsp;
    <ion-input
      [formControl]="customerCtrl"
      placeholder="{{ 'General.Type2Search' | translate }}"
      #customerSearch
    ></ion-input>
    <ion-button fill="none" (click)="clearSearch()" class="ion-input-button">
      <ion-icon name="close"></ion-icon>
    </ion-button>
  </ion-item>

  <!-- Flervalg: valgte kunder beholdes på tvers av søk -->
  <div class="selected-chips" *ngIf="multiSelect && selectedCustomers.size > 0">
    <ion-chip
      *ngFor="let entry of selectedCustomers | keyvalue"
      color="primary"
      (click)="unselect(entry.value.CustomerNo)"
    >
      <ion-label>{{ entry.value.Name }}</ion-label>
      <ion-icon name="close-circle"></ion-icon>
    </ion-chip>
  </div>

  <ion-list>
    <ion-item
      *ngFor="let customer of filteredCustomers | async"
      [button]="multiSelect"
      [detail]="false"
      [disabled]="multiSelect && !isSelectable(customer)"
      [class.is-selected]="multiSelect && selectedCustomers.has(customer.CustomerNo)"
      (click)="selectCustomer(customer)"
    >
      <ion-checkbox
        *ngIf="multiSelect"
        slot="start"
        class="multi-checkbox"
        [checked]="isAlreadyAdded(customer) || selectedCustomers.has(customer.CustomerNo)"
        aria-hidden="true"
      ></ion-checkbox>
      <ion-label
        [ngClass]="{ 'alert-danger': customer.CustomerBlockedStatus > 0 }"
      >
        <strong>{{ customer.Name }} </strong> -
        <ion-badge class="ion-badge">
          {{
            customer.CustomerNo == 0 ? "Ny kunde" : customer.CustomerNo
          }}</ion-badge
        >
         <ion-badge class="ion-badge-outline" *ngIf="customer.CustomerNo != 0 && customer.Company">
          {{ customer.Company }}</ion-badge
        >

        <ion-icon
          name="alert-circle-outline"
          *ngIf="customer.CustomerBlockedStatus > 0"
          class="alert-danger"
          title="Kreditsperret"
        ></ion-icon>
        <br />
        {{ customer.Address }} {{ customer.Address2 }},
        {{ customer.PostalCode }} {{ customer.City }}
      </ion-label>
      <ion-note slot="end" *ngIf="multiSelect && isAlreadyAdded(customer)">{{
        "Picker.alreadyAdded" | translate
      }}</ion-note>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer *ngIf="multiSelect">
  <ion-toolbar>
    <ion-button
      expand="block"
      class="multi-confirm"
      [disabled]="selectedCustomers.size === 0"
      (click)="confirmSelection()"
    >
      <ion-icon name="add-outline" slot="start"></ion-icon>
      {{ "Picker.addSelected" | translate: { count: selectedCustomers.size } }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
